import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { RiverRundownService } from 'src/app/Services/riverrundown.service';

import * as moment from 'moment';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { TripContextService } from 'src/app/Services/trip-context.service';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';
import { AXRundownItem, AXRiverRunDownResponse } from 'src/app/Models/ax-river-rundown';

@Component({
  selector: 'app-myday-glance',
  templateUrl: './myday-glance.component.html',
  styleUrls: ['./myday-glance.component.css'],
  providers: [RiverRundownService],
  encapsulation: ViewEncapsulation.None,
})
export class MydayGlanceComponent {
  @Input() inputdate: string | undefined;
  expanditem = false;
  userdata?: UserData;
  evtCode: string | undefined;
  rebcode: string | undefined;
  shipname = '';
  somshpID: number | undefined;
  evtcode: string | undefined;
  OBPortalSvcURL = '';

  SailingThroughDay: AXRundownItem[] = [];
  LookingTowardTomorrow: AXRundownItem[] = [];
  DailyHighlights: AXRundownItem[] = [];


  RiverrundownInfo: AXRundownItem[] = [];
  RiverrundownAddinInfo: AXRundownItem[] = [];
  TomorrowRiverrundownInfo: AXRundownItem[] = [];
  TomorrowRiverrundownAddinInfo: AXRundownItem[] = [];
  HighlightInfo: AXRundownItem[] = [];
  asofdate: string | undefined;
  tomorrowasofdate: string | undefined;
  enddate: string | undefined;
  tomorrowenddate: string | undefined;
  hashighlights: boolean = false;
  futureactivities: boolean = false;
  currentdate: Date = new Date();
  showtomorrow: boolean = false;
  newriverrundownitem: any;
  tomorrownewriverrundownitem: any;
  filterpastout: boolean = false;

  currentdatestring: string | undefined;
  CurrentTime: string | undefined;
  pagemask: boolean | undefined; 

  constructor(
    private appConfigService: AppConfigService,
    private RiverRundownService: RiverRundownService,
    private tripContextService: TripContextService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.evtCode = cruiseContentEvtCodeFromSession(this.userdata);
    this.rebcode = this.userdata?.rebcode;
    this.shipname = this.userdata?.ShipName!;
    this.somshpID = this.userdata?.shipid!;
    this.evtcode = this.userdata?.evtcode;

    this.pagemask = this.tripContextService.resolve(this.userdata).pagemask;

    if (this.inputdate == '') {
      this.asofdate = moment().format('YYYY-MM-DD') + ' 00:00:00';
      this.enddate = moment().add(1, 'days').format('YYYY-MM-DD');
      this.tomorrowasofdate = moment().add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00';
      this.tomorrowenddate = moment().add(2, 'days').format('YYYY-MM-DD');
    }
    else {
      this.asofdate = moment(this.inputdate).format('YYYY-MM-DD') + ' 00:00:00';
      this.enddate = moment(this.inputdate).add(1, 'days').format('YYYY-MM-DD');
      this.tomorrowasofdate = moment(this.inputdate).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00';
      this.tomorrowenddate = moment(this.inputdate).add(2, 'days').format('YYYY-MM-DD');
    }

    if (moment().isAfter(moment().format('YYYY-MM-DD') + ' 17:00:00')) {
      this.showtomorrow = true;
    }
    this.currentdate = moment().toDate();
    this.getRiverRundown();

  }
  datecompare(date1: Date | string, date2: Date | string) {
    if (moment(date1) == moment(date2)) return 'equal';
    if (moment(date1) > moment(date2)) return 'greater';
    else return 'less';
  }
  getRiverRundown() {
      this.RiverRundownService.AXRiverRunDown(
        this.rebcode ?? null,
        this.evtCode ?? '',
        moment(this.asofdate).format('YYYY-MM-DD')
      ).subscribe((httpResponse) => {

        // AFTER WE GET THE RIVER RUN DOWN DATA ENTER THE FUNCTION BELOW TO SET TODAYS DATA...
        this.setRiverRundown(httpResponse)

        // IF THERE IS A PAGE MASK THEN WE CAN ALSO GO FORWARD AND SET TOMORROWS DATA AS WELL...
        if (this.pagemask == false) this.setTomorrowRiverRundown(httpResponse);
      });

  }

  setRiverRundown(res: any) {

    if (res.result.status !== 'A') return;
  
    // THERE IS TWO PLACES THE DATA CAN BE STORED, SO IF ONE LOCATION DNE THEN TRY THE OTHER..
    this.RiverrundownInfo =  res.data.today;
    
    this.RiverrundownInfo?.forEach((item: AXRundownItem) => {
      if (item.type == 'Cruise' && item.direction == 'Arrive') {
        item.endafterbeforecurrent = this.datecompare(item.begDate, this.currentdate);
      } else {
        item.endafterbeforecurrent = this.datecompare(item.endDate, this.currentdate);
      }
      item.begingafterbeforecurrent = this.datecompare(item.begDate, this.currentdate);

      if (item.isHighlighted && item.endafterbeforecurrent != 'less') {
        this.HighlightInfo.push(item);
        this.hashighlights = true;

        if (this.pagemask == true) {
          this.DailyHighlights = this.HighlightInfo.filter((h) => h.type != 'HT' && h.type != 'OT');
        } else if (this.pagemask == false) {
          this.DailyHighlights = this.HighlightInfo;
        }
      }

      if (item.endafterbeforecurrent != 'less') {
        this.futureactivities = true;
      }

      item.samestardate = moment(item.begDate).format('YYYY-MM-DD') == moment(this.currentdate).format('YYYY-MM-DD');
      item.sameenddate = moment(item.endDate).format('YYYY-MM-DD') == moment(this.currentdate).format('YYYY-MM-DD');

      if (item.type == 'Cruise' && item.samestardate) {
        item.displayordertime = item.begDate.toString();
        item.arrivedepart = 'Arrive';
      } else if (item.type == 'Cruise' && !item.samestardate) {
        item.displayordertime = item.endDate.toString();
        item.arrivedepart = 'Depart';
      } else if (item.type != 'Cruise') {
        item.displayordertime = item.begDate.toString();
      }

      if (item.type == 'HT' && item.description?.includes('|')) {
        item.description = item.description.replaceAll('|', ' \n');
      }
      if (item.type == 'HT' && item.location?.includes('|')) {
        item.location = item.location.replaceAll('|', ', ');
      }
    });

    for (let i = 0; i < this.RiverrundownInfo?.length; i++) {
      if (
        i > 0 &&
        this.RiverrundownInfo[i].name == this.RiverrundownInfo[i - 1].name &&
        this.RiverrundownInfo[i].begDate == this.RiverrundownInfo[i - 1].begDate
      ) {
        this.RiverrundownInfo[i - 1].guestName += ', ' + this.RiverrundownInfo[i].guestName;
        this.RiverrundownInfo[i].deduper = true;
      }
      if (this.RiverrundownInfo[i].type == 'Cruise') {
        this.RiverrundownInfo[i].description = this.RiverrundownInfo[i].description?.replace('|', ' | ');
      }
    }

    if (this.pagemask == true) {
      this.SailingThroughDay = this.RiverrundownInfo.filter((r) => r.type != 'HT' && r.type != 'OT');
    } else if (this.pagemask == false) {
      this.SailingThroughDay = this.RiverrundownInfo;
    }
  }

  setTomorrowRiverRundown(res: AXRiverRunDownResponse) {
    if (res.result.status !== 'A') return;

    this.TomorrowRiverrundownInfo = res.data.tomorrow;

    this.TomorrowRiverrundownInfo?.forEach((item: AXRundownItem) => {
      item.endafterbeforecurrent = this.datecompare(item.endDate, this.currentdate);
      item.begingafterbeforecurrent = this.datecompare(item.begDate, this.currentdate);

      item.samestardate = moment(item.begDate).format('YYYY-MM-DD') == moment(this.tomorrowasofdate).format('YYYY-MM-DD');
      item.sameenddate = moment(item.endDate).format('YYYY-MM-DD') == moment(this.tomorrowasofdate).format('YYYY-MM-DD');

      if (item.type == 'Cruise' && item.samestardate) {
        item.displayordertime = item.begDate.toString();
        item.endafterbeforecurrent = this.datecompare(item.begDate, this.currentdate);
        item.arrivedepart = 'Arrive';
      } else if (item.type == 'Cruise' && !item.samestardate) {
        item.displayordertime = item.endDate.toString();
        item.arrivedepart = 'Depart';
      } else if (item.type != 'Cruise') {
        item.displayordertime = item.begDate.toString();
      }

      if (item.type == 'HT' && item.description?.includes('|')) {
        item.description = item.description.replaceAll('|', ' \n');
      }
      if (item.type == 'HT' && item.location?.includes('|')) {
        item.location = item.location.replaceAll('|', ', ');
      }
    });

    for (let i = 0; i < this.TomorrowRiverrundownInfo?.length; i++) {
      if (
        i > 0 &&
        this.TomorrowRiverrundownInfo[i].name == this.TomorrowRiverrundownInfo[i - 1].name &&
        this.TomorrowRiverrundownInfo[i].begDate == this.TomorrowRiverrundownInfo[i - 1].begDate
      ) {
        this.TomorrowRiverrundownInfo[i - 1].guestName += ', ' + this.TomorrowRiverrundownInfo[i].guestName;
        this.TomorrowRiverrundownInfo[i].deduper = true;
      }
      if (this.TomorrowRiverrundownInfo[i].type == 'Cruise') {
        this.TomorrowRiverrundownInfo[i].description =
          this.TomorrowRiverrundownInfo[i].description?.replace('|', ' | ');
      }
    }

    if (this.pagemask == true) {
      this.LookingTowardTomorrow = this.TomorrowRiverrundownInfo.filter((r) => r.type != 'HT' && r.type != 'OT');
    } else if (this.pagemask == false) {
      this.LookingTowardTomorrow = this.TomorrowRiverrundownInfo;
    }
  }
}
